import React from 'react';
import { SectionHeading } from './SectionHeading';
import { Reveal } from './Reveal';
import { painPoints } from '../data/landing';
export function ProblemSection() {
  return <section className="border-t border-white/5 bg-ink-deep py-16 sm:py-24" data-id="element-146" data-mp="30gxtpw8ufdm8">
      <div className="mx-auto max-w-6xl px-4 sm:px-6" data-id="element-147" data-mp="30jahwr572k7q">
        <SectionHeading title="¿Te está pasando esto?" tone="dark" data-id="element-148" data-mp="2vpg2hzwmgreg" />
        <ul className="mt-10 grid gap-4 md:grid-cols-3 md:gap-6" data-id="element-149" data-mp="39hm9avdvxm18">
          {painPoints.map((pain, i) => <Reveal as="li" key={pain.emoji} delay={i * 0.05} className="h-full" data-id="element-150" data-mp="35gtzo113pf4f" data-mpi={i}>
              <div className="flex h-full flex-col rounded-2xl border border-white/10 bg-white/[0.04] p-6" data-id="element-151" data-mp="3jftnj6gshpzj">
                <span className="text-4xl" aria-hidden="true" data-id="element-152" data-mp="3egh1up1nmoyj">{pain.emoji}</span>
                <p className="mt-4 text-base leading-relaxed text-slate-200 sm:text-lg" data-id="element-153" data-mp="1p213ij0xaida">{pain.text}</p>
              </div>
            </Reveal>)}
        </ul>
        <Reveal className="mt-10 text-center" data-id="element-154" data-mp="1k4sj0bsay28v">
          <p className="text-lg font-bold text-white sm:text-xl" data-id="element-155" data-mp="jddb84xia6ty">
            Si dijiste <span className="text-success-light" data-id="element-156" data-mp="jbahpax59vkh">sí</span> a cualquiera de estas, este sistema es para ti.
          </p>
        </Reveal>
      </div>
    </section>;
}